import appIcon from "../assets/app-icon.svg";

export function Footer() {
  const year = new Date().getFullYear();
  return `
        <footer class="footer">
            <div class="container">
                <div class="footer-content">
                    <div class="footer-brand">
                        <div class="brand-logo-footer">
                            <img src="${appIcon}" alt="WU Thasala" />
                        </div>
                        <div class="brand-info">
                            <h3 class="brand-title">WU Thasala</h3>
                            <p class="brand-subtitle">Mobile Application สำหรับบุคลากรมหาวิทยาลัยวลัยลักษณ์</p>
                        </div>
                    </div>

                    <div class="footer-links">
                        <div class="footer-section">
                            <h4 class="footer-heading">ดาวน์โหลด</h4>
                            <a href="https://apps.apple.com/us/app/wu-thasala/id6747904778" target="_blank" rel="noopener" class="footer-link">
                                <svg viewBox="0 0 24 24" fill="currentColor" class="link-icon">
                                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                                </svg>
                                App Store
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=com.cdtwu.thasalaapp" target="_blank" rel="noopener" class="footer-link">
                                <svg viewBox="0 0 24 24" fill="currentColor" class="link-icon">
                                    <path d="M3.609 1.814L13.792 12 3.609 22.186a.996.996 0 0 1-.609-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.802 8.99l-2.303 2.303-8.635-8.635z"/>
                                </svg>
                                Google Play
                            </a>
                        </div>
                    </div>
                </div>

                <div class="footer-bottom">
                    <div class="footer-copyright">
                        <p>© ${year} WU Thasala. All rights reserved.</p>
                    </div>
                    <div class="powered-by">
                        <span>Powered by</span>
                        <img class="powered-logo" src="https://hrms.wu.ac.th/img/cdtwu.png" alt="CDT WU" loading="lazy"/>
                    </div>
                </div>
            </div>
        </footer>
    `;
}
